module.exports = __webpack_public_path__ + "static/media/screenshot.466807b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/gazoo-racing/screenshot.jpg
// module id = 816
// module chunks = 0